import { useEffect, useCallback } from 'react';
import { localStorageEnum } from '../../api/enums';
import useAuth from '../../hooks/useAuth';
import { Alert } from '@piggytechng/component-library';

const CHECK_INTERVAL = 5000; // 5 sec
const SESSION_TIMEOUT = 2 * 60 * 60 * 1000; // 2 hours

const InactivityLogoutTimer = () => {
  const { logout } = useAuth();

  const checkForInactivity = useCallback(() => {
    const expireTime = parseInt(localStorage.getItem(localStorageEnum['local.storage.sessionExpiryTime']) || '0', 10);

    if (expireTime === 0) return;

    if (expireTime <= Date.now() && window.location.pathname !== '/login') {
      Alert.info('Logged out due to inactivity. Please log in to continue.');
      logout();
    }
  }, [logout]);

  const updateExpiryTime = useCallback(() => {
    localStorage.setItem(
      localStorageEnum['local.storage.sessionExpiryTime'],
      (Date.now() + SESSION_TIMEOUT).toString(),
    );
  }, []);

  useEffect(() => {
    const interval = setInterval(checkForInactivity, CHECK_INTERVAL);
    return () => clearInterval(interval);
  }, [checkForInactivity]);

  useEffect(() => {
    const events = ['click', 'keypress', 'scroll', 'mousemove', 'focus', 'load', 'mousemove', 'touchstart'];

    events.forEach((event) => window.addEventListener(event, updateExpiryTime));

    return () => {
      events.forEach((event) => window.removeEventListener(event, updateExpiryTime));
    };
  }, [updateExpiryTime]);

  return null;
};

export default InactivityLogoutTimer;
